export function generateTestId(headline: string, prefix: string) {
  const headlineParts = headline?.split(' ').map((part) => {
    const part1 = part[0].toUpperCase() + part.substring(1, part.length);
    return part1;
  });
  headline = headlineParts?.join('');

  return `${prefix}${headline}`;
}
